export default "__VITE_ASSET__E_D_z_zx__"